import { CUSTOMER_TYPES } from "../../pages/dashboard/jobs/vonigo/components/CustomerDetailsSection"

export function getExistingCustomerType(optionId) {
    const test = Object?.values(CUSTOMER_TYPES)?.find((t) => {
        return t.optionId === `${optionId}`
    })
    return test?.name;
}